import type { ReactNode } from 'react'

import type { StatsData } from '../../../analyticsModule/components/AnalyticsCard/AnalyticsCard.types'

type CreateStatsDataOptions<T> = {
  rows?: unknown[]
  limit?: number
  mapFn: (rowData: T) => { label: ReactNode; value: number }
}

export const createStatsData = <T>({
  rows,
  limit = 5,
  mapFn,
}: CreateStatsDataOptions<T>): StatsData[] => {
  return rows?.slice(0, limit).map((rowData: unknown) => mapFn(rowData as T)) || []
}
